import { formatPercentage } from 'toolbox/format'
import greenMove from 'assets/logos/movement-move-green.svg'

export function StakeYieldRate({
  stakeYieldRate,
  baseRate,
  rewardRate,
  stakeYieldIcon,
  stakeYieldTicker
}: {
  stakeYieldRate: number
  baseRate: number
  rewardRate: number
  stakeYieldIcon: string
  stakeYieldTicker: string
}) {
  return (
    <div className="reward-rate-display">
      {rewardRate > 0 && (
        <div className="pill">
          {'+'}
          <p>{formatPercentage(rewardRate)}</p>
          <img src={greenMove} alt="MOVE" />
        </div>
      )}
      <div className="stake-yield-pill">
        {'+'}
        <p>{formatPercentage(stakeYieldRate)}</p>
        <img src={stakeYieldIcon} alt={stakeYieldTicker} />
      </div>
    </div>
  )
}
